export default "__VITE_ASSET__CUzH1FuZ__"